// removed by extract-text-webpack-plugin
module.exports = {"overlay":"overlay--qmJws"};